import { useState, useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BrowserCheck() {
  const [isSupported, setIsSupported] = useState<boolean>(true);
  const [missingFeatures, setMissingFeatures] = useState<string[]>([]);
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    const missing: string[] = [];

    // 1. Check: Audio API
    if (!window.AudioContext && !window.webkitAudioContext) {
      missing.push("Web Audio API");
    }

    // 2. Check: MediaRecorder
    // Hinweis: TypeScript kennt MediaRecorder normalerweise, aber wir prüfen zur Sicherheit den Typ
    if (typeof MediaRecorder === "undefined") {
      missing.push("Mikrofon-Aufnahme (MediaRecorder)");
    }

    // 3. Check: WebSockets
    if (typeof WebSocket === "undefined") {
      missing.push("WebSockets");
    }

    // 4. Check: Modernes JavaScript
    if (!window.Promise || !window.fetch) {
      missing.push("Modern JavaScript (ES6)");
    }

    if (missing.length > 0) {
      setMissingFeatures(missing);
      setIsSupported(false);
    }
  }, []);

  if (isSupported || !isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-950/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-500">
      <div className="bg-white max-w-md w-full rounded-2xl p-6 shadow-2xl border-2 border-red-100 text-center">
        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
          <AlertTriangle className="w-8 h-8 text-red-500" />
        </div>

        <h2 className="text-xl font-bold text-slate-900 mb-2">Browser nicht unterstützt</h2>

        <p className="text-sm text-slate-600 mb-6 leading-relaxed">
          Für das KI-Sprachtraining werden moderne Browser-Funktionen benötigt, die dein aktueller
          Browser leider nicht unterstützt.
        </p>

        <div className="bg-red-50/50 border border-red-100 p-4 rounded-xl text-left mb-6">
          <p className="text-[10px] font-bold text-red-800 mb-2 uppercase tracking-wider">
            Fehlende Technik:
          </p>
          <ul className="list-disc list-inside text-xs text-red-700 font-mono space-y-1">
            {missingFeatures.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        </div>

        <div className="space-y-3">
          <Button
            className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl shadow-lg shadow-indigo-500/20"
            onClick={() => (window.location.href = "https://www.google.com/chrome/")}
          >
            Google Chrome herunterladen
          </Button>

          <button
            onClick={() => setIsVisible(false)}
            className="text-xs text-slate-400 hover:text-slate-600 underline py-2"
          >
            Ich weiß was ich tue (Trotzdem fortfahren)
          </button>
        </div>
      </div>
    </div>
  );
}
